/** @jsx jsx **/
import { jsx } from "@emotion/react";
import { useMemo } from "react";

import { usePageViewLog } from "@hooks";
import { webLogScreenName, webLogPageCategory, webLogEventName } from "@types";

import * as styles from "./main.style";

import Footer from "./footer";
import Header from "./header";
import Notice from "./Notice";

export function Main() {
  const pageviewLog = useMemo(
    () => ({
      screenName: webLogScreenName.travelscanner,
      pageCategory: webLogPageCategory.title,
      eventName: webLogEventName.travelscanner,
    }),
    []
  );

  usePageViewLog(pageviewLog);

  return (
    <main css={styles.scrollWrapper}>
      <Header />
      <div css={styles.centerBox}>
        <Notice />
      </div>
      <Footer />
    </main>
  );
}
